var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.filterFold ? "展开筛选" : "收起筛选") +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _vm.resData
                      ? _c(
                          "div",
                          { staticStyle: { padding: "10px 25px" } },
                          [
                            _c(
                              "el-form",
                              {
                                ref: "form",
                                attrs: {
                                  model: _vm.form,
                                  "label-width": "85px"
                                }
                              },
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 10 } },
                                  [
                                    _c(
                                      "el-col",
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "输入搜索：" } },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 2 } },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    placeholder: "代采员"
                                                  },
                                                  nativeOn: {
                                                    keyup: function($event) {
                                                      if (
                                                        !$event.type.indexOf(
                                                          "key"
                                                        ) &&
                                                        _vm._k(
                                                          $event.keyCode,
                                                          "enter",
                                                          13,
                                                          $event.key,
                                                          "Enter"
                                                        )
                                                      ) {
                                                        return null
                                                      }
                                                      return _vm.search.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value: _vm.form.admin_name,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "admin_name",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.admin_name"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 2 } },
                                              [
                                                _vm.resData
                                                  ? _c(
                                                      "el-select",
                                                      {
                                                        attrs: {
                                                          placeholder: "代采组",
                                                          filterable: ""
                                                        },
                                                        model: {
                                                          value: _vm.form.pgid,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.form,
                                                              "pgid",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "form.pgid"
                                                        }
                                                      },
                                                      [
                                                        _c("el-option", {
                                                          attrs: {
                                                            label: "全部",
                                                            value: ""
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          _vm.resData.option
                                                            .pgOption,
                                                          function(item) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: item.key1,
                                                                attrs: {
                                                                  value:
                                                                    item.key1,
                                                                  label:
                                                                    item.label
                                                                }
                                                              }
                                                            )
                                                          }
                                                        )
                                                      ],
                                                      2
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 2 } },
                                              [
                                                _vm.resData
                                                  ? _c(
                                                      "el-select",
                                                      {
                                                        attrs: {
                                                          placeholder: "角色",
                                                          filterable: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.form.role_type,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.form,
                                                              "role_type",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "form.role_type"
                                                        }
                                                      },
                                                      [
                                                        _c("el-option", {
                                                          attrs: {
                                                            label: "全部",
                                                            value: ""
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          _vm.resData.option
                                                            .roleOption,
                                                          function(item) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: item.key,
                                                                attrs: {
                                                                  value:
                                                                    item.key,
                                                                  label:
                                                                    item.label
                                                                }
                                                              }
                                                            )
                                                          }
                                                        )
                                                      ],
                                                      2
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 3 } },
                                              [
                                                _vm.resData
                                                  ? _c(
                                                      "el-select",
                                                      {
                                                        attrs: {
                                                          placeholder: "城市",
                                                          filterable: ""
                                                        },
                                                        model: {
                                                          value: _vm.form.city,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.form,
                                                              "city",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "form.city"
                                                        }
                                                      },
                                                      [
                                                        _c("el-option", {
                                                          attrs: {
                                                            label: "全部",
                                                            value: ""
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          _vm.resData.option
                                                            .cityOption,
                                                          function(item) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: item.key,
                                                                attrs: {
                                                                  value:
                                                                    item.key,
                                                                  label:
                                                                    item.label
                                                                }
                                                              }
                                                            )
                                                          }
                                                        )
                                                      ],
                                                      2
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 3 } },
                                              [
                                                _vm.resData
                                                  ? _c(
                                                      "el-select",
                                                      {
                                                        attrs: {
                                                          placeholder: "状态"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.form.status,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.form,
                                                              "status",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "form.status"
                                                        }
                                                      },
                                                      [
                                                        _c("el-option", {
                                                          attrs: {
                                                            label: "全部",
                                                            value: ""
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          _vm.resData.option
                                                            .statusOption,
                                                          function(
                                                            item,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: index,
                                                                attrs: {
                                                                  label:
                                                                    item.label,
                                                                  value:
                                                                    item.key
                                                                }
                                                              }
                                                            )
                                                          }
                                                        )
                                                      ],
                                                      2
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 2 } },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: { type: "primary" },
                                                    on: { click: _vm.search }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        查询"
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _vm.resData
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      background: "#f3f3f3",
                      height: "50px",
                      "line-height": "30px",
                      padding: "0 25px",
                      display: "flex",
                      "align-items": "center"
                    }
                  },
                  [
                    _c("div", [
                      _vm._v("数据汇总 ：" + _vm._s(_vm.resData.count) + "人")
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "auto" },
                        attrs: { type: "warning", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.AddMember(0)
                          }
                        }
                      },
                      [_vm._v("添加人员\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success", size: "mini" },
                        on: { click: _vm.output }
                      },
                      [_vm._v("导出")]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "margin-bottom": "0" } },
                  [
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.tableLoading,
                            expression: "tableLoading"
                          }
                        ],
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          height: "600",
                          data: _vm.resData.list,
                          "tooltip-effect": "dark"
                        },
                        on: { "selection-change": _vm.handleSelectionChange }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "purchase_group_member_city",
                            label: "城市",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "pgname",
                            label: "代采组",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return _vm._l(
                                    _vm.hanlePg(scope.row.pgname),
                                    function(item, index) {
                                      return _c("p", { key: index }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(item) +
                                            "\n              "
                                        )
                                      ])
                                    }
                                  )
                                }
                              }
                            ],
                            null,
                            false,
                            914166895
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "admin_name",
                            label: "代采员",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "purchase_group_member_role_type",
                            label: "角色",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "supply_num",
                            label: "绑定商家数量",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.supply_num > 0
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function($event) {
                                                return _vm.handleClick(
                                                  scope.row.pg_member_id
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(scope.row.supply_num))]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.supply_num == 0
                                      ? _c("span", [
                                          _vm._v(_vm._s(scope.row.supply_num))
                                        ])
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3596683124
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "buyer_version",
                            label: "代采版本",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "storage_version",
                            label: "仓储版本",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "mobile",
                            label: "手机号码",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "wx_nick_name",
                            label: "微信昵称",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "purchase_group_member_status",
                            label: "状态",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "",
                            label: "操作",
                            align: "center",
                            width: "100"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { size: "small", type: "text" },
                                        on: {
                                          click: function($event) {
                                            return _vm.AddMember(
                                              scope.row.pg_member_id
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("编辑")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { size: "small", type: "text" },
                                        on: {
                                          click: function($event) {
                                            return _vm.showLogList(
                                              scope.row.pg_member_id
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("操作日志\n              ")]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1379928882
                          )
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.curPage,
                        background: "",
                        layout: "total, prev, pager, next, jumper ",
                        total: _vm.resData.count,
                        "page-size": 10
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.curPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.curPage = $event
                        },
                        "current-change": _vm.handleCurrentChange
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.showlog
        ? _c(
            "div",
            [
              _c("log", {
                attrs: { id: _vm.id, "log-type": _vm.log_type },
                on: { onCloseDialog: _vm.closeBox }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showbox
        ? _c(
            "div",
            [
              _c("edit-member", {
                attrs: { id: _vm.id },
                on: { onCloseDialog: _vm.closeBox }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d8d54cf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d8d54cf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/purchasegroup/Member.vue
// module id = null
// module chunks = 